import apolloClient from '../apolloClient';
import { FORGET_PASSWORD_MUTATION } from './mutations/forgotPassword';

/**
 * Request password reset code via GraphQL
 * Returns { success, type, message }
 * type can be: "reset_code_sent", "no_account", "account_inactive", etc.
 */
export const fetchForgotPasswordGraphQL = async ({ email }) => {
  try {
    const { data, errors } = await apolloClient.mutate({
      mutation: FORGET_PASSWORD_MUTATION,
      variables: {
        input: {
          email
        }
      }
    });

    // Handle GraphQL errors
    if (errors && errors.length > 0) {
      const errorMessage = errors[0]?.message || errors[0]?.extensions?.message || 'An error occurred while processing your request';
      const error = new Error(errorMessage);
      error.graphQLErrors = errors;
      throw error;
    }

    // Handle case where data is null
    if (!data || !data.forgetPassword) {
      throw new Error('No data returned from the server');
    }

    return data.forgetPassword;
  } catch (error) {
    console.error('Error requesting password reset:', error);
    // If it's already an Error with a message, re-throw it
    if (error instanceof Error) {
      throw error;
    }
    // Otherwise, wrap it in an Error
    throw new Error(error.message || 'An unexpected error occurred');
  }
};

